









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'ToolTip'
})
export default class ToolTip extends Vue {
  @Prop({
      required: false,
      default: "left",
      validator(value) {
          return [
            "right",
            "left"
          ].includes(value);
        }
      }) placement!: string
  @Prop({required: false, default: null}) title!: string | null

  
}
